import currentPartner from '../constants/partners';
import { ISSOLoginConfig } from '../contexts/ssoLoginContext';
import { IHttpCall } from '../hooks/useHttpCall';

/**
 * Stores SSO session data in sessionStorage for use after redirect.
 * Called before redirecting to external SSO provider.
 *
 * @param loginHttpCall - The HTTP call configuration for completing login after redirect
 */
export const storeSSOSessionData = (loginHttpCall: IHttpCall): void => {
  // Store loginHttpCall config for when we return from SSO provider
  sessionStorage.setItem('sso_login_http_call', JSON.stringify(loginHttpCall));

  // Store partner basePath for redirect handling after auth
  if (currentPartner?.basePath) {
    sessionStorage.setItem('sso_partner_path', currentPartner.basePath);
  }

  // Store original query params to restore after SSO flow
  // Mainly to preserve the `redirect` query param and be able to deeplink
  if (window.location.search) {
    sessionStorage.setItem('sso_original_params', window.location.search);
  }
};

/**
 * Handles external SSO redirect if ssoProviderUrl is present.
 * Stores necessary session data and redirects to the SSO provider.
 *
 * @param ssoConfig - The SSO login configuration
 * @returns true if redirect was initiated, false otherwise
 */
export const handleExternalSSORedirect = (
  ssoConfig: ISSOLoginConfig | undefined
): boolean => {
  if (ssoConfig?.type === 'external' && ssoConfig.ssoProviderUrl) {
    // Store session data before redirect
    storeSSOSessionData(ssoConfig.loginHttpCall);

    // Navigate to SSO provider URL immediately
    window.location.href = ssoConfig.ssoProviderUrl;
    return true;
  }

  return false;
};
